<template>
    <nav class="ArticleNavigation Wrapper-nav" v-if="dataLoaded && ArticlePage">
        <ArticleNavHome class="custom-ArticleNavigationSide ArticleNavigationSide ArticleNavigationSide_home" />
        <div class="custom-ArticleNavigationSide ArticleNavigationSide ArticleNavigationSide_previous" v-if="isFirst"></div>
        <ArticleNavPrevious class="custom-ArticleNavigationSide ArticleNavigationSide ArticleNavigationSide_previous" v-else />
        <div class="custom-ArticleNavigationSide ArticleNavigationSide ArticleNavigationSide_next" v-if="isLast"></div>
        <ArticleNavNext class="custom-ArticleNavigationSide ArticleNavigationSide ArticleNavigationSide_next" v-else />
    </nav>
</template>

<script>
    import store from '@/store';

    export default {
        name: 'ArticleNavigation',
        components: {
            'ArticleNavHome': () => import('@/components/ArticleNavHome'),
            'ArticleNavPrevious': () => import('@/components/ArticleNavPrevious'),
            'ArticleNavNext': () => import('@/components/ArticleNavNext')
        },
        computed: {
            dataLoaded() {
                return store.state.loaded;
            },
            isFirst() {
                return (store.state.currentArticleIndex === 0);
            },
            isLast() {
                return (store.state.currentArticleIndex === store.state.articlesFullList.length - 1);
            },
            /**
             * @return {boolean}
             */
            ArticlePage() {
                return (store.state.currentPageType === 'article');
            },
            currentArticleIndex() {
                return store.state.currentArticleIndex;
            },
            currentArticle: () => {
                return store.state.currentArticle;
            }
        },
        data() {
            return {};
        }
    };
</script>
